import { http } from "services/http";

import type {
  ApiVendorAddRequest,
  ApiVendorsResponse,
  ApiVendorUpdateRequest,
  CalculateTxRequest,
  PaymentsSelectRequest,
  PsAddRequest,
  PsAddResponse,
  PsBalance,
  PsEditResponse,
  PsFormOptions,
  PsIdRequest,
  PsListItem,
  PsSaveMessages,
  PsUpdateRequest,
  SendTxRequest,
  TxFeeOption,
} from "models/ps.model";
import type { SelectOption } from "models/common.model";

export const psApi = {
  getPayments: (data?: PaymentsSelectRequest) =>
    http.quiet().post<SelectOption[]>("/api/get-payments", data ? { ...data } : null),
  calculateIncomes: (data: CalculateTxRequest) =>
    http.quiet().post<TxFeeOption[]>("/api/payments/calculate-tx", { ...data }),
  saveSendIncomes: (data: SendTxRequest) => http.quiet().post("/api/payments/send-tx", { ...data }),
  getOptions: () => http.quiet().get<PsFormOptions>("/api/payments/add"),
  savePs: (data: PsAddRequest) => http.quiet().post<PsAddResponse>("/api/payments/add", { ...data }),
  getPs: (data: PsIdRequest) => http.quiet().post<PsEditResponse>("/api/payments/edit", { ...data }),
  getPsList: () => http.quiet().get<PsListItem[]>("/api/payments"),
  updatePs: (data: PsUpdateRequest) =>
    http.quiet().post<PsSaveMessages>("/api/payments/update", { ...data }),
  getAPIs: () => http.quiet().get<ApiVendorsResponse>("/api/payments-api"),
  updateAPI: (data: ApiVendorUpdateRequest) =>
    http.quiet().post("/api/payments-api/update", { ...data }),
  getAPIsData: () => http.quiet().get<ApiVendorsResponse>("/api/payments-api/add"),
  addAPI: (data: ApiVendorAddRequest) => http.quiet().post("/api/payments-api/add", { ...data }),
  refreshBalance: (data: PsIdRequest) =>
    http.quiet().post<PsBalance>("/api/payments/balance-update", { ...data }),
};
